import { Checkbox, Field, TextAreaInput, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { FieldSet } from 'Components/Layout';
import { valueOrDefault } from 'Lib/Any';
import { useSelector } from 'react-redux';
import { pipe } from 'rxjs';
import { ICoreFieldProps } from './types';

let AdditionalVisualDescription: React.FC<ICoreFieldProps> = ({
  createWorksheetSelector,
  editable = false,
  visible = true,
  appendNamePrefix = '',
}) => {
  const additionalVisualDescriptionRequired = useSelector(
    pipe(createWorksheetSelector!(`${appendNamePrefix}.AdditionalVisualDescriptionRequired`), valueOrDefault(false))
  );

  const additionalVisualDescription = useSelector(
    createWorksheetSelector!(`${appendNamePrefix}.AdditionalVisualDescription`)
  );

  if (!visible) {
    return null;
  }

  return (
    <NamePrefixModifier appendNamePrefix={appendNamePrefix}>
      {editable ? (
        <FieldSet>
          <Field
            input={<Checkbox />}
            label="Additional Visual Description Required"
            name="AdditionalVisualDescriptionRequired"
            confirm={({ value }) => value === false && additionalVisualDescription}
            confirmText="The Additional Visual Description field will be cleared."
            confirmButtonText="Confirm"
          />
          <Field
            input={<TextAreaInput />}
            label="Visual Description"
            name="AdditionalVisualDescription"
            visible={additionalVisualDescriptionRequired}
            maxLength={150}
          />
        </FieldSet>
      ) : (
        <FieldSet>
          <Field
            input={<TextOutput />}
            label="Visual Description"
            name="AdditionalVisualDescription"
            value={additionalVisualDescriptionRequired ? undefined : 'Additional visual description not required'}
          />
        </FieldSet>
      )}
    </NamePrefixModifier>
  );
};

AdditionalVisualDescription = withInjectedProps(AdditionalVisualDescription);

export { AdditionalVisualDescription };
